import type { FAQItem } from './FAQSection';

interface FAQSchemaProps {
  /** Array of FAQ items to include in the schema */
  items: FAQItem[];
}

/**
 * Renders FAQPage JSON-LD structured data for SEO.
 * Enables FAQ rich snippets in Google search results.
 *
 * Should be placed alongside FAQSection with the same items.
 */
export function FAQSchema({ items }: FAQSchemaProps): React.JSX.Element {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}
